module.exports = __webpack_public_path__ + "img/zhuanpan.ccb24493.png";